import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import discordImage from '../assets/discord.png';
import lustImage from '../assets/lust.png';

function LustPage(): React.ReactElement {
  return (
    <Container maxWidth="md" sx={{ mt: 4, textAlign: 'center' }}>
      <Typography variant="h4" gutterBottom>
        SHOPIFY HYPE
      </Typography>
      <Typography variant="body1" paragraph>
        ABRE TU DISCORD Y BUSCA A @LUST
      </Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 4,
          flexWrap: 'wrap',
        }}
      >
        <img
          src={discordImage}
          alt="Discord Logo"
          style={{
            width: '300px',
            height: '300px',
            objectFit: 'contain',
            borderRadius: '12px',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
          }}
        />
        <img
          src={lustImage}
          alt="Lust Logo"
          style={{
            width: '300px',
            height: '300px',
            objectFit: 'contain',
            borderRadius: '12px',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
          }}
        />
      </Box>
    </Container>
  );
}

export default LustPage;
